import React, { useState } from "react";

import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import SelectQ from "../../../components/FormComponents/SelectQ/SelectQ";
import ErrorMessage from "../../../components/TableBionovaQ/ErrorMessage/ErrorMessage";
import InputQ from "../../../components/FormComponents/InputQ/InputQ";

import request from "../../../utils/request";

import styles from "./MaterialsForm.module.css";
import CheckBoxQ from "../../../components/FormComponents/CheckBoxQ/CheckBoxQ";
import SpinnerQ from "../../../components/SpinnerQ/SpinnerQ";

const MaterialsForm = ({
  formData,
  handleFormData,
  handleClose,
  open,
  locale,
  t,
  getMaterials,
  materialsType,
  methods,
  handleOpenMaterialType,
}) => {
  const [error, setError] = useState("");
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    if (loading) return;
    setLoading(true);
    e.preventDefault();
    if (
      !formData.materialTypeId ||
      !formData.name.trim() ||
      !formData.methodId ||
      !formData.cyclesWarning ||
      (!formData.serial && formData.isSerialized)
    ) {
      setValidate(true);
      return;
    } else setValidate(false);

    try {
      const bodyRequest = {
        ...formData,
      };

      if (formData.id) {
        await request().put("/api/material", bodyRequest);
      } else {
        await request().post("/api/material", bodyRequest);
      }
      handleClose();
      setError("");
      setValidate(false);
      getMaterials();
    } catch (err) {
      setError(
        err.response?.data?.message || "Error al guardar el esterilizador."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (name === "isSerialized" && !checked) {
      handleFormData((prevFormData) => ({
        ...prevFormData,
        serial: "",
      }));
    }

    if (name === "isImplant" && checked) {
      handleFormData((prevFormData) => ({
        ...prevFormData,
        isImplant: true,
        isEndoscope: false,
      }));
      return;
    }

    if (name === "isEndoscope" && checked) {
      handleFormData((prevFormData) => ({
        ...prevFormData,
        isImplant: false,
        isEndoscope: true,
      }));
      return;
    }

    handleFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };

  const onClose = () => {
    handleClose();
    setError("");
    setValidate(false);
  };

  return (
    <ModalQ
      open={open}
      title={
        !formData.id
          ? t("NewMaterial", locale) || "New Material"
          : t("EditMaterial", locale) || "Edit Material"
      }
      handleClose={onClose}
    >
      {error && <ErrorMessage message={error} />}
      {loading ? (
        <div className="spinnerContainer">
          <SpinnerQ />
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.inputGroup}>
            <InputQ
              containerWidth={"48%"}
              labelTop={true}
              label={t("NameSpan") || "Name"}
              name="name"
              handleChange={handleInputChange}
              value={formData.name}
              required={true}
              validate={validate}
              leftMessage={true}
            />
            <div className={styles.itemWithForm}>
              <SelectQ
                selectValue={formData.materialTypeId}
                handleSelect={handleSelectChange}
                containerWidth={"80%"}
                options={materialsType}
                name={"materialTypeId"}
                placeholder={
                  t("BlankEntry96", locale) || "Select a Material Type"
                }
                label={
                  t("SelectMaterialType", locale) || "Select a Material Type"
                }
                labelTop={true}
                required={true}
                validate={validate}
              />
              <p onClick={handleOpenMaterialType} className={styles.addForm}>
                Add Material Type
              </p>
            </div>
          </div>

          <div className={styles.inputGroup}>
            <SelectQ
              selectValue={formData.methodId}
              handleSelect={handleSelectChange}
              containerWidth={"48%"}
              options={methods}
              name={"methodId"}
              placeholder={
                t("BlankEntry99", locale) || "Select a Suggested Method"
              }
              label={t("BlankEntry99", locale) || "Select a Suggested Method"}
              labelTop={true}
              required={true}
              validate={validate}
            />
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <CheckBoxQ
                name="isImplant"
                checked={formData.isImplant}
                onChange={handleCheckboxChange}
                label={t("BlankEntry93") || "Is Implant"}
              />
              <CheckBoxQ
                name="isEndoscope"
                checked={formData.isEndoscope}
                onChange={handleCheckboxChange}
                label={t("BlankEntry94") || "Is Endoscope/Cannulated"}
              />
            </div>
          </div>

          <div className={styles.inputGroup}>
            <div style={{ width: "24%", marginTop: "15px" }}>
              <CheckBoxQ
                name="isSerialized"
                checked={formData.isSerialized}
                onChange={handleCheckboxChange}
                label={t("BlankEntry97") || "Serialized material"}
              />
            </div>
            <InputQ
              containerWidth="48%"
              labelTop={true}
              label={t("SerialSpan", locale) || "Serial"}
              name="serial"
              handleChange={handleInputChange}
              value={formData.serial}
              required={formData.isSerialized}
              validate={validate}
              disabled={!formData.isSerialized}
            />
          </div>

          <div className={styles.inputGroup}>
            <InputQ
              containerWidth="48%"
              labelTop={true}
              label={t("BlankEntry95") || "Cycles Warning"}
              name="cyclesWarning"
              handleChange={handleInputChange}
              value={formData.cyclesWarning}
              required={true}
              validate={validate}
              leftMessage={true}
            />
            <InputQ
              containerWidth="48%"
              labelTop={true}
              label={t("ObservationSpan", locale) || "Observations"}
              name="observations"
              handleChange={handleInputChange}
              value={formData.observations}
            />
          </div>

          <button
            className={`${styles.button} ${styles.confirmButton}`}
            onClick={(e) => handleSubmit(e)}
            disabled={loading}
          >
            Confirm
          </button>
        </div>
      )}
    </ModalQ>
  );
};

export default MaterialsForm;
